// extracted by mini-css-extract-plugin
module.exports = {"main":"Likes_main__3JhWW","backbutton":"Likes_backbutton__1HiJy","gallery":"Likes_gallery__1JNoI"};